(ns teamoesterreich.admin-mode.text-blocks.text-block-trigger-helper
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [teamoesterreich.view-state :as v-state]
    [teamoesterreich.util.log :as log]
    ))



(defn- get-trigger-obj []
  (get-in v-state/TEXT_MAP [:toeTextTrigger]))


(defn get-trigger->name []
  (let [names (reduce (fn [c0 [k0 e0]]
                        (reduce (fn [c1 [k1 e1]]
                                  (reduce (fn [c2 [k2 ob]]
                                            (assoc c2 k2 (or (:name ob) "")))
                                          c1 e1))
                                c0 e0))
                      {} (get-trigger-obj))]
    names)
  )



(defn get-name [group type key]
  (let [triggerObj (get-trigger-obj)]
    ;(log/debug "get-name " group type key ")")
    (str (or (get-in triggerObj [(keyword group) (keyword type) (keyword key) :name])
             (str key)))))



(defn get-group-triggers [group type]
  (let [triggerObj (get-trigger-obj)
        res (reduce (fn [c [k e]] (conj c [k (:name e)])) [] (get-in triggerObj [(keyword group) (keyword type)]))]
    ;(log/debug "get-group-triggers " group type ")" (clj->js res) (clj->js (get-in triggerObj [(keyword group)])))
    (or
      res
      {})))